/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Checkbox } from 'sarsaparilla';

import { ACTIVITY_TAG_OPTIONS } from '../../../constants/activityTags';
import type { ActivityTagOption } from '../../../constants/activityTags';

interface ActivityTagFilterItem {
    key: string;
    value: string;
    filters: { attribute: string; filterValue: string }[];
}

interface ActivityTagsFiltersProps {
    uiFilters: {
        activityTags?: Record<string, unknown>;
    };
    onFilterToggle: (filterName: string, item: ActivityTagFilterItem) => void;
}

function toFilterItem(option: ActivityTagOption): ActivityTagFilterItem {
    return {
        key: option.value,
        value: option.label,
        filters: [
            {
                attribute: 'activity_tags',
                filterValue: option.value,
            },
        ],
    };
}

export function ActivityTagsFilters({
    uiFilters,
    onFilterToggle,
}: ActivityTagsFiltersProps) {
    const selections = uiFilters.activityTags || {};

    const handleChange = (option: ActivityTagOption) => {
        onFilterToggle('activityTags', toFilterItem(option));
    };

    return (
        <div
            className="search-filters-double-type-wrap"
            role="group"
            aria-label="Nearby activity filters"
        >
            <legend className="rec-sr-only">Select nearby activities to filter on</legend>
            {ACTIVITY_TAG_OPTIONS.map((option) => {
                const isChecked = Object.hasOwn(selections, option.value);
                return (
                    <div className="search-filter-check-item" key={option.value}>
                        <Checkbox
                            onChange={() => handleChange(option)}
                            id={`activity-tag_${option.value}`}
                            label={option.label}
                            value={option.value}
                            isChecked={isChecked}
                        />
                    </div>
                );
            })}
        </div>
    );
}

// cSpell:ignore horseback
